"use client";

import { Fragment, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { QuestionMarkCircleIcon, XMarkIcon } from "@heroicons/react/24/outline";

export default function ManageGroupHelpDrawer() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div className="flex justify-end">
        <p
          className="text-sm text-gray-400 text-sm flex items-center cursor-pointer"
          onClick={() => setOpen(true)}
        >
          <QuestionMarkCircleIcon className="h-4 w-4 inline mr-1" /> Need help?
        </p>
      </div>
      <Transition.Root show={open} as={Fragment}>
        <Dialog open={open} onClose={setOpen} className="relative z-10">
          <Transition.Child
            as={Fragment}
            enter="transform transition ease-in-out duration-300 sm:duration-500"
            enterFrom="translate-x-full"
            enterTo="translate-x-0"
            leave="transform transition ease-in-out duration-300 sm:duration-500"
            leaveFrom="translate-x-0"
            leaveTo="translate-x-full"
          >
            <Dialog.Backdrop className="fixed inset-0 bg-gray-500/75 dark:bg-black/80 transition-opacity duration-500 ease-in-out data-[closed]:opacity-0" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-hidden">
            <div className="absolute inset-0 overflow-hidden">
              <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
                <Transition.Child
                  as={Fragment}
                  enter="transform transition ease-in-out duration-300 sm:duration-500"
                  enterFrom="translate-x-full"
                  enterTo="translate-x-0"
                  leave="transform transition ease-in-out duration-300 sm:duration-500"
                  leaveFrom="translate-x-0"
                  leaveTo="translate-x-full"
                >
                  <Dialog.Panel className="pointer-events-auto w-screen max-w-md transform transition duration-500 ease-in-out data-[closed]:translate-x-full sm:duration-700">
                    <div className="flex h-full flex-col overflow-y-scroll bg-white dark:bg-dark-secondary py-6 shadow-xl">
                      <div className="px-4 sm:px-6">
                        <div className="flex items-start justify-between">
                          <Dialog.Title className="text-base font-semibold text-gray-900 dark:text-white">
                            Help with Managing your Group
                          </Dialog.Title>
                          <div className="ml-3 flex h-7 items-center">
                            <button
                              type="button"
                              onClick={() => setOpen(false)}
                              className="relative rounded-md bg-white dark:bg-transparent text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                            >
                              <span className="absolute -inset-2.5" />
                              <span className="sr-only">Close panel</span>
                              <XMarkIcon
                                aria-hidden="true"
                                className="size-6"
                              />
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="relative mt-6 flex-1 px-4 sm:px-6 text-gray-400">
                        <p>
                          This is where you can manage access for your group.
                          You have been assigned a set of tickets by the event
                          organiser. You can add members of your group and
                          assign tickets to them.
                        </p>
                        <br />
                        <p>
                          To add someone, just click "Add person". To remove
                          them, click the trash can for that row. If you want to
                          email them their tickets, press the mail icon.
                        </p>
                        <br />
                        <p>
                          If you delete someone who has tickets allocated to
                          them, their tickets will be revoked and become
                          available to be re-allocated.
                        </p>
                      </div>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  );
}
